export default __webpack_public_path__ + "static/media/complete.1d2dba25.svg";